export default __webpack_public_path__ + "static/media/BrainBreak cards36.e52bd81a.png";